export default __webpack_public_path__ + "static/media/boatpic1.57f0f2b7.jpg";